import {clsx, type ClassValue} from 'clsx';
import {twMerge} from 'tailwind-merge';

declare global {
	interface Window {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ignore
		fbq: any;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ignore
		gtag: any;
	}
}

export const WEBINAR_DATE = new Date(2025, 6, 30, 20, 0);
export const OMA_AI_DATE = new Date(2025, 5, 16, 22, 0);

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function pluralize(n: number, singular: string, paucal: string, plural: string) {
	const nAbs = Math.abs(n);
	if (nAbs === 1) return singular;
	if (nAbs % 10 >= 2 && nAbs % 10 <= 4 && !(nAbs % 100 >= 12 && nAbs % 100 <= 14)) {
		return paucal;
	}
	return plural;
}

export function pluralizeDays(n: number) {
	return n === 1 ? 'dzień' : 'dni';
}

export function trackEvent(action: string, params?: object) {
	if (!window.gtag) return;

	window.gtag('event', action, params);
}
